"use client";

import { FileSpreadsheet } from "lucide-react";

export interface SpreadsheetPreviewProps {
  filename: string;
  citedText: string;
  pageNumber?: number | undefined;
}

export function SpreadsheetPreview({ filename, citedText, pageNumber }: SpreadsheetPreviewProps) {
  return (
    <div className="p-3 space-y-2">
      <div className="flex items-center gap-2 text-xs text-green-600 dark:text-green-400 font-medium">
        <FileSpreadsheet className="h-3.5 w-3.5 flex-shrink-0" />
        <span className="truncate">{filename}</span>
        {pageNumber && (
          <>
            <span className="text-stone-300 dark:text-stone-600">&bull;</span>
            <span>Sheet {pageNumber}</span>
          </>
        )}
      </div>
      {/* quovy-lint-ignore prefer-notice -- highlight for quoted source text, not a status message */}
      <div className="bg-green-50 dark:bg-green-950/30 rounded-md p-2 border border-green-100 dark:border-green-900 font-mono">
        <p className="text-xs text-stone-700 dark:text-stone-200 leading-relaxed line-clamp-4 whitespace-pre-wrap">
          {citedText}
        </p>
      </div>
    </div>
  );
}
